import { MapTemplate } from 'types';

import first from 'style/imgs/mapTemplate/1.png';
import second from 'style/imgs/mapTemplate/2.png';
import third from 'style/imgs/mapTemplate/3.png';
import fourth from 'style/imgs/mapTemplate/4.png';
import fifth from 'style/imgs/mapTemplate/5.png';
import sixth from 'style/imgs/mapTemplate/6.png';
import seventh from 'style/imgs/mapTemplate/7.png';
import eighth from 'style/imgs/mapTemplate/8.png';

const Imgs = [
  { id: MapTemplate.littlePigs, locked: false, url: first },
  { id: MapTemplate.fantasyLand, locked: false, url: second },
  { id: MapTemplate.undersea, locked: false, url: third },
  { id: MapTemplate.futureCity, locked: false, url: fourth },
  { id: MapTemplate.design5, locked: true, url: fifth },
  { id: MapTemplate.design6, locked: true, url: sixth },
  { id: MapTemplate.design7, locked: true, url: seventh },
  { id: MapTemplate.design8, locked: true, url: eighth },
];

export default Imgs;
